import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import RefundRequestModal from './RefundRequestModal';
import RefundApproveModal from './RefundApproveModal';

/**
 * v0.8.1 — 学员卡详情 modal (辉哥拍板 B 方案: 浮层点「详情」必须弹 modal)
 * v0.8.5 — 加「已消课 N 节」明细 + 统一无限次判定 (辉哥 10/7 拍板)
 *   无限次卡判定: total=0 || remaining=-1 (跟后端 StudentCard::isUnlimited() 口径一致)
 *   「已消课 N 节」: 来自父级传入的 c.consumed_count (ListLessonsController L128 v0.8.5 已返)
 *
 * v0.18.62 — 加**退卡 / 审批退卡**两个入口 (辉哥 10/23 拍板, 设计稿 v4 · S1 / S6)
 *   ⛔ **可见性只读后端下发的能力标志**:
 *      · 「退卡」     ⇒ `card.can_refund === true`
 *      · 「审批退卡」 ⇒ `card.refund_status === 'pending'` **且** `card.can_approve_refund === true`
 *   ⛔ **没权限时整颗按钮不渲染** (不是 disabled、不是隐藏) —— 设计稿 S6 明文。
 *   ⛔ 现有内容 (卡种 / 课时 / 已消课 / 过期) **一个字都不许删改** —— 本轮只**加** footer。
 *
 * 用途: 学员卡 chip 点 tap / hover 浮层里的「详情」按钮触发
 * 内容只显示卡名 + 模板 + 课时 + 已消 + 过期信息, 不做提交
 */
export default class CardDetailModal extends Modal {
  className() {
    return 'Modal--small ZS-CardDetailModal';
  }
  title() {
    const c = this.attrs.card || {};
    return c.template_name || '学员卡 #' + c.id;
  }

  // v0.8.5 — 统一无限次判定 (跟后端 StudentCard::isUnlimited() 口径一致)
  //   改前: CardDetailModal L37 / StudentsListTab L643 L768 各处自己写 `remaining_lessons === -1`
  //   改后: 走 isUnlimited(c) 方法, 后端改口径 (e.g. 加新的哨兵) 前端一处更新即可
  isUnlimited(c) {
    if (!c) return false;
    return c.total_lessons === 0 || c.remaining_lessons === -1;
  }

  // ── v0.18.62 — 退卡 / 审批入口的**可见性** (⛔ 整颗按钮不渲染, 不是 disabled) ──
  canRefund(c) {
    return !!(c && c.can_refund === true);
  }
  canApproveRefund(c) {
    return !!(c && c.refund_status === 'pending' && c.can_approve_refund === true);
  }
  content() {
    const c = this.attrs.card || {};
    const exp = c.expires_at ? c.is_expired ? '已过期 ' + Math.abs(c.expires_in_days || 0) + ' 天' : c.expires_in_days !== null && c.expires_in_days <= 7 ? c.expires_in_days + ' 天后过期' : c.expires_at + ' 到期' : '无过期时间';
    const unlimited = this.isUnlimited(c);
    const consumed = typeof c.consumed_count === 'number' ? c.consumed_count : null;
    const showRefund = this.canRefund(c);
    const showApprove = this.canApproveRefund(c);
    return m('[', null, m("div", {
      style: "padding: 14px 4px; min-width: 320px;"
    }, m("div", {
      style: "margin-bottom: 10px;"
    }, m("div", {
      style: "font-size: 12px; color: var(--zs-text-2-9ca3af, #9ca3af); margin-bottom: 4px;"
    }, "\u5361\u79CD"), m("div", {
      style: "font-size: 14px; color: var(--zs-text-1-e5e7eb, #e5e7eb);"
    }, c.template_name || '学员卡 #' + c.id)), m("div", {
      style: "margin-bottom: 10px;"
    }, m("div", {
      style: "font-size: 12px; color: var(--zs-text-2-9ca3af, #9ca3af); margin-bottom: 4px;"
    }, "\u8BFE\u65F6"), m("div", {
      style: "font-size: 14px; color: var(--zs-text-1-e5e7eb, #e5e7eb);"
    }, unlimited ? '不限次' : c.remaining_lessons + ' / ' + c.total_lessons + ' 课时')), !unlimited && consumed !== null && m("div", {
      style: "margin-bottom: 10px;"
    }, m("div", {
      style: "font-size: 12px; color: var(--zs-text-2-9ca3af, #9ca3af); margin-bottom: 4px;"
    }, "\u5DF2\u6D88\u8BFE"), m("div", {
      style: "font-size: 14px; color: var(--zs-text-1-e5e7eb, #e5e7eb);"
    }, consumed, " \u8282")), m("div", {
      style: "margin-bottom: 10px;"
    }, m("div", {
      style: "font-size: 12px; color: var(--zs-text-2-9ca3af, #9ca3af); margin-bottom: 4px;"
    }, "\u8FC7\u671F"), m("div", {
      style: "font-size: 14px; color: var(--zs-text-1-e5e7eb, #e5e7eb);"
    }, exp)), c.is_expired ? m("div", {
      style: "font-size: 12px; color: var(--zs-danger-f87171, #f87171); margin-top: 14px;"
    }, m("i", {
      className: "fas fa-lock",
      "aria-hidden": "true"
    }), " \u5DF2\u9501\u5B9A, \u9700\u300C\u5EF6\u671F\u89E3\u9501\u300D\u540E\u624D\u80FD\u7EE7\u7EED\u4F7F\u7528") : null), (showRefund || showApprove) && m("div", {
      className: "Modal-footer"
    }, showRefund && m(Button, {
      className: "Button Button--refund ZS-CardDetailModal-submit",
      onclick: () => {
        // 🔴 v0.18.65 — ⛔ **不要**先 this.hide()
        //   Flarum 2.0 的 `app.modal.show()` **默认就把整个弹窗栈替换掉**
        //   (`keepStack` 默认 false ⇒ `modalList = [this.modal]`),
        //   本弹窗会自动消失 ⇒ 根本不需要先关。
        //   ⛔ 而「先 hide() 再 show()」会**锁死全站弹窗**:
        //     hide() → ModalManager.animateHide() ⇒ `modalClosing = true`,
        //     并在**本弹窗的 DOM 元素**上挂 `transitionend` 监听;
        //     紧接着 show() 把本弹窗的 DOM 移除 ⇒ transitionend 永不触发
        //     ⇒ `state.close()` 永不执行 ⇒ `modalClosing` 永久停在 true
        //     ⇒ 之后**任何**弹窗的 hide() 都在 `if (modalClosing) return;` 处返回
        //     ⇒ 取消 / × / Esc 全部失效, **全站弹窗从此关不掉**。
        app.modal.show(RefundRequestModal, {
          card: c
        });
      }
    }, m("i", {
      className: "fas fa-undo"
    }), " \u9000\u5361"), showApprove && m(Button, {
      className: "Button Button--approve ZS-CardDetailModal-approve",
      onclick: () => {
        // 🔴 v0.18.65 — 同上: ⛔ 不要先 this.hide() (ModalManager.modalClosing 闩锁)
        app.modal.show(RefundApproveModal, {
          card: c
        });
      }
    }, "\u5BA1\u6279\u9000\u5361")));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/modal/CardDetailModal', CardDetailModal);